<template>
  <v-app>
    <LeftPanel />
    <RightPanel />

    <AppBar />

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import LeftPanel from '@/components/manage/LeftPanel.vue';
import AppBar from '@/components/manage/AppBar.vue';
import RightPanel from '@/components/manage/RightPanel.vue';

export default {
  components: {
    LeftPanel,
    AppBar,
    RightPanel
  }
};
</script>
